import { notification, Modal, message } from 'antd';
import cloneDeep from 'lodash/cloneDeep';
import {
  submitNewShop,
  fetchInitShopInfo,
  fetchQualificationStructure,
  preCheck,
  preDuplicating,
} from '@/services/api';
import { fetchPhoneAreaCode } from '@/services/basic';
import { fetchNewCoordinates, fetchNewAddressByCoordinates } from '@/services/geographic';
import router from 'umi/router';
import { getShopInfo } from '@/utils/logicUtils';
import { QUALIFICATIONS_GROUP } from '@/configs/newShop';
import { LAND_LINE } from '@/components/Phone/const';
import { getSceneValue } from '@/utils/sceneInfo';
import { ROLE } from '../configs/poi';

const DEFAULT_SHOP_INFO = {
  shopName: '',
  branchName: '',
  cityId: '',
  districtId: '',
  address: '',
  backCateId: '',
  phoneList: [],
  longitude: 121.4737, // 上海市中心
  latitude: 31.23037,
  bizTime: {
    businessTimeList: [],
    specialTimeList: [],
  },
  openStatus: 0,
  picInfos: [],
  comment: '',
  areaCode: '', // 对应城市的电话区号
  userLat: null, // 用户的经纬度
  userLng: null,
  nonLngLat: null, // 是否知道门店的准确位置
};
const OTHER_HELP_INFO = {
  telType: ['mobile'], // 默认展示手机号码
  isUserChangeAddress: 0, // 用户有没有手动输入地址, 1有手动操作过0没有
  isUserAdjustMap: 0, // 用户有没有调整过地图, 1拖动0未拖动
  qualificationStructure: [],
  qualificationLoading: 0,
  preDuplicatingTooltip: false, // 是否第一次展示 Tooltip
  preDuplicatingTooltipVisible: false, // 是否正在展示 Tooltip
  preDuplicatingModal: {
    visible: false,
    tooltipVisible: false,
    dupShop: {},
  },
};

const requiredFieldMap = {
  shopName: '门店名称',
  longitude: '门店位置',
  address: '详细地址',
  districtId: '所在地区',
  backCateId: '后台品类',
};

const delay = time => new Promise(resolve => setTimeout(resolve, time));
export default {
  namespace: 'newShop',

  state: {
    originNewShopInfo: DEFAULT_SHOP_INFO,
    newShopInfo: DEFAULT_SHOP_INFO,
    otherHelpInfo: OTHER_HELP_INFO,
    formValue: {}, // 用于暂存表单值
    resultInfo: {},
    aiResult: {},
  },

  effects: {
    *checkCanPreDuplicating({ payload }, { select }) {
      const newShopInfo = yield select(state => state.newShop.newShopInfo);
      const formValue = yield select(state => state.newShop.formValue);

      const requiredFields = [];
      Object.keys(requiredFieldMap).forEach(key => {
        const value = newShopInfo[key] || formValue[key];
        let hasValue = false;
        if (Array.isArray(value)) hasValue = !!value?.length;
        else hasValue = !!value;
        if (!hasValue) {
          requiredFields.push(requiredFieldMap[key]);
        }
      });

      return requiredFields;
    },
    *updateFormValue({ payload }, { put, select, call }) {
      yield put({
        type: 'setFormValue',
        payload,
      });

      const otherHelpInfo = yield select(state => state.newShop.otherHelpInfo);

      if (!otherHelpInfo.preDuplicatingTooltip) {
        const requiredFields = yield yield put({
          type: 'checkCanPreDuplicating',
        });
        if (!requiredFields.length) {
          yield put({
            type: 'setHelpInfo',
            payload: {
              // preDuplicatingTooltip: true,
              preDuplicatingTooltipVisible: true,
            },
          });
          yield call(delay, 5000);
          yield put({
            type: 'setHelpInfo',
            payload: {
              preDuplicatingTooltipVisible: false,
            },
          });
        }
      }

      yield put({
        type: 'fetchQualificationStructure',
      });
    },
    *updateNewShopInfo({ payload }, { put }) {
      yield put({
        type: 'setNewShopInfo',
        payload,
      });
    },
    fetchQualificationStructure: [
      function*({ payload }, { call, select, put }) {
        const { currentUser } = yield select(state => state.user);
        if (currentUser.role !== ROLE.SALES) return;
        yield put({
          type: 'setHelpInfo',
          payload: {
            qualificationLoading: 1,
          },
        });
        const {
          picInfos,
          provinceId,
          cityId,
          districtId,
          latitude,
          longitude,
          backCateId,
        } = yield select(state => state.newShop.newShopInfo);
        const { shopName, branchName, bizTime, openStatus, address, phoneList } = yield select(
          state => state.newShop.formValue
        );
        const data = yield call(
          fetchQualificationStructure,
          {
            provinceId,
            cityId,
            districtId,
            latitude,
            longitude,
            shopName,
            branchName,
            bizTime: JSON.stringify(bizTime),
            coordType: 'GCJ02',
            openStatus,
            address,
            phoneList,
            backCateId,
            picInfos,
            sceneInfo: getSceneValue('create-shop'),
          },
          'shopAdd',
          ({ code, msg = '', data = '' }) => {
            console.error(code, msg, data);
            // notification.error({
            //   message: '提交失败',
            //   description: msg,
            //   duration: 0,
            // });
          }
        );
        yield put({
          type: 'setHelpInfo',
          payload: {
            qualificationStructure: data ? data.qualificationStructures : [],
            qualificationLoading: 0,
          },
        });
      },
      { type: 'throttle', ms: 1000 },
    ],
    *fetchAddressByCoordinates({ payload }, { call, put }) {
      const { latitude, longitude } = payload;
      const address = yield call(fetchNewAddressByCoordinates, payload);
      if (address) {
        yield put({
          type: 'setNewShopInfo',
          payload: {
            address,
            latitude,
            longitude,
          },
        });
      }
    },
    *fetchCoordinatesAndSetAddressInBaseInfo({ payload }, { call, put, select }) {
      const response = yield call(fetchNewCoordinates, payload) || {};
      yield put({
        type: 'setNewShopInfo',
        payload: {
          ...response,
        },
      });
    },
    *fetchPhoneAreaCode({ payload }, { call, put, select }) {
      const { form, ...params } = payload;
      const areaCode = yield call(fetchPhoneAreaCode, params);
      let { reporterPhone, phoneList } = form.getFieldsValue();
      // 城市变化区号自动变化
      phoneList = phoneList?.map(item => {
        item.type === LAND_LINE && (item.areaCode = areaCode);
        return item;
      });
      reporterPhone &&
        (reporterPhone = reporterPhone.map(item => {
          item.type === LAND_LINE && (item.areaCode = areaCode);
          return item;
        }));
      form.setFieldsValue({
        phoneList,
        reporterPhone,
      });
      yield put({
        type: 'setNewShopInfo',
        payload: {
          areaCode,
          phoneList,
        },
      });
    },
    *fetchInitShopInfo({ payload }, { call, put }) {
      const response = yield call(fetchInitShopInfo, payload);
      const newShopInfo = getShopInfo(response);
      if (newShopInfo) {
        yield put({
          type: 'initNewShopInfo',
          payload: {
            newShopInfo,
          },
        });
      }
    },
    *newShopInfoError({ payload }, { put, select }) {
      let forceSubmit;
      const { code, msg = '', data = {} } = payload;
      const { dupShop, aiResult } = data || {};
      const role = yield select(state => state.user.currentUser.role);
      switch (code) {
        case 703:
          yield put({
            type: 'setField',
            payload: {
              aiResult,
            },
          });
          break;
        case 704: // 704 前置AI字段toast弹框提示aiResult.message
          // GC解析分值低于70分
          if (aiResult && ~['r300001447', 'r300001621'].indexOf(aiResult.ruleCode)) {
            const { newShopInfo } = yield select(state => state.newShop);
            forceSubmit = yield new Promise(resolve => {
              const modal = Modal.confirm({
                title: '信息确认',
                width: 450,
                okText: '继续提交',
                cancelText: '立即修改',
                content: (
                  <div>
                    请您再次确认门店的地址信息
                    <div>
                      城市：
                      {newShopInfo.provinceName}
                      {newShopInfo.cityName}
                      {newShopInfo.districtName}
                    </div>
                    <div>
                      地址：
                      {payload.address}
                    </div>
                  </div>
                ),
                onOk() {
                  modal.destroy();
                  resolve(true);
                  LXAnalytics('moduleClick', 'b_dianping_nova_t06oe4go_mc');
                },
                onCancel() {
                  modal.destroy();
                  resolve(false);
                  LXAnalytics('moduleClick', 'b_dianping_nova_qqt1a4r9_mc');
                },
              });
            });
            LXAnalytics('moduleView', 'b_dianping_nova_bxnr0uu2_mv');
            return { forceSubmit };
          } else {
            Modal.error({
              title: '提示',
              content: <div>{(aiResult && aiResult.message) || msg}</div>,
              okText: '关闭',
            });
          }
          break;
        case 705:
          // eslint-disable-next-line compat/compat
          forceSubmit = yield new Promise(resolve => {
            Modal.confirm({
              content: aiResult.message || msg,
              okText: '继续提交',
              cancelText: '返回修改',
              onOk() {
                resolve(true);
              },
              onCancel() {
                resolve(false);
              },
            });
          });
          return { forceSubmit };
        case 723: // 723 判重重复提交,弹框展示 msg
          Modal.error({
            title: '提示',
            content: <div>{(aiResult && aiResult.message) || msg}</div>,
            okText: '关闭',
          });
          break;
        case 720: // 720 确定重复,正常商户且非关门商户
        case 721: // 721 确定重复,正常商户且关门商户
        case 722: // 722 确定重复,异常商户,弹框
          // 销售走新逻辑
          if (role === ROLE.SALES) {
            yield put({
              type: 'user/mv',
              payload: 'b_pdc_56wyuk1z_mv',
            });
            yield put({
              type: 'setField',
              payload: {
                resultInfo: {
                  newDuplicateModalVisible: true,
                  payload,
                  dupShop,
                  content: msg,
                  dupCode: code,
                },
              },
            });
          } else {
            const groupData = [
              QUALIFICATIONS_GROUP.brand,
              QUALIFICATIONS_GROUP.business,
              QUALIFICATIONS_GROUP.transfer,
            ];
            if (code === 721) {
              // 关门门店
              // 其它情况需要加上营业状态选项
              groupData.unshift(QUALIFICATIONS_GROUP.status);
              LXAnalytics('moduleClick', 'b_dianping_nova_lt7lkuka_mv');
            } else {
              // 正常门店
              LXAnalytics('moduleClick', 'b_dianping_nova_fgo59n5w_mv');
            }
            yield put({
              type: 'setField',
              payload: {
                resultInfo: {
                  visible: true,
                  payload,
                  dupShop,
                  content: msg,
                  groupData,
                },
              },
            });
            break;
          }
          break;
        case 728: // 728 弹框展示 msg
          forceSubmit = yield new Promise(resolve => {
            Modal.error({
              title: '提示',
              content: aiResult.message || msg,
              okText: aiResult.buttonTxtList[0] || '关闭',
              onOk() {
                resolve(true);
              },
            });
          });
          return { forceSubmit };
          break;
        case 901:
          notification.error({
            message: '提交失败',
            description: msg,
            duration: 0,
          });
          yield put({
            type: 'user/permissionReject',
            payload: {
              code: 901,
            },
          });
          break;
        default:
          notification.error({
            message: '提交失败',
            description: msg,
            duration: 0,
          });
          break;
      }
    },
    *preCheckNewShopInfo({ payload }, { call, put, select }) {
      const response = yield call(preCheck, { ...payload, bizType: 2 });
      if (!response) return;
      if (response.code === 200) {
        return true;
      } else {
        return yield put({ type: 'newShopInfoError', payload: response });
      }
    },
    *preDuplicatingNewShopInfo({ payload }, { call, put }) {
      const mge = (type = 'mc', payload = []) =>
        put({
          type: `user/${type}`,
          payload,
        });
      const checkMc = result => mge('mc', ['b_pdc_45wozmc4_mc', { custom: { result } }]);
      yield put({
        type: 'setHelpInfo',
        payload: {
          preDuplicatingTooltip: true,
        },
      });
      const response = yield call(preDuplicating, { ...payload });
      const { code, data = {} } = response || {};
      if (code === 200) {
        yield checkMc(0);
        yield mge('mv', 'b_pdc_chpobr00_mv');
        message.info('未发现门店重复');
      } else {
        yield checkMc(1);
        yield mge('mv', 'b_pdc_03kud3zs_mv');
        yield mge('mv', 'b_pdc_9a1v52si_mv');
        yield mge('mv', 'b_pdc_pqabqw2z_mv');
        yield mge('mv', 'b_pdc_ktw2g90p_mv');
        yield put({
          type: 'newShop/togglePreDuplicatingModal',
          payload: data,
        });
      }
    },
    *submitNewShopInfo({ payload }, { call, put, select }) {
      const response = yield call(submitNewShop, payload);
      if (!response) return;
      const { code, msg = '', data = {} } = response;
      if (code === 200) {
        yield put({
          type: 'success/setSuccessField',
          payload: {
            flowId: data.flowId,
            successTextHtml: msg,
          },
        });
        // 如果是新增连锁跳转到有商户信息的成功页面，新增跳转到单纯的成功页面
        const url = (payload.groupId ? '/errors' : '') + '/result/success';
        router.push(url);
      } else {
        return yield put({ type: 'newShopInfoError', payload: response });
      }
    },
  },

  reducers: {
    initNewShopInfo(state, action) {
      const { payload = {} } = action;
      const newShopInfo = cloneDeep({
        ...DEFAULT_SHOP_INFO,
        ...payload.newShopInfo,
      });
      return {
        ...state,
        originNewShopInfo: cloneDeep(newShopInfo),
        newShopInfo,
        otherHelpInfo: OTHER_HELP_INFO,
        resultInfo: {},
        aiResult: {},
      };
    },
    setNewShopInfo(state, action) {
      const { payload } = action;
      const { newShopInfo } = state;
      return {
        ...state,
        newShopInfo: {
          ...newShopInfo,
          ...payload,
        },
      };
    },
    setFormValue(state, { payload }) {
      return {
        ...state,
        formValue: payload || {},
      };
    },
    setHelpInfo(state, action) {
      const { payload } = action;
      const { otherHelpInfo } = state;
      return {
        ...state,
        otherHelpInfo: {
          ...otherHelpInfo,
          ...payload,
        },
      };
    },
    togglePreDuplicatingModal(state, { payload }) {
      const { otherHelpInfo } = state;

      return {
        ...state,
        otherHelpInfo: {
          ...otherHelpInfo,
          preDuplicatingModal:
            typeof payload === 'boolean'
              ? {
                  ...otherHelpInfo.preDuplicatingModal,
                  visible: false,
                }
              : {
                  ...payload,
                  visible: true,
                },
        },
      };
    },
    setField(state, action) {
      const { payload } = action;
      return {
        ...state,
        ...payload,
      };
    },
  },
};
